











import { Component, Prop, Vue } from 'vue-property-decorator';
import FirebaseMessage from '@/components/FirebaseMessage.vue';
import OrderListMobile from './OrderReportListMobile.vue';
import OrderListDesktop from './OrderReportListDesktop.vue';

@Component({
  components: {
    OrderListMobile,
    OrderListDesktop,
    FirebaseMessage
  }
})
export default class OrderReportList extends Vue {
  @Prop(Boolean) isMobile!: boolean;
}
